import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
  RouterOutlet
} from '@angular/router';
import { startWith } from 'rxjs';

import { AppFooterComponent } from '../footer/app-footer.component';
import { AppHeaderComponent } from '../header/app-header.component';
import { AppShellStateService } from './app-shell-state.service';

@Component({
  selector: 'app-shell',
  imports: [
    RouterOutlet,
    AppHeaderComponent,
    AppFooterComponent
  ],
  templateUrl: './app-shell.component.html',
  styleUrl: './app-shell.component.css'
})
export class AppShellComponent {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly appShellState = inject(AppShellStateService);

  protected readonly useElevatedContentSurface = signal(true);
  protected readonly appChromeVisible =
    this.appShellState.appChromeVisible;

  constructor() {
    this.router.events
      .pipe(
        startWith(null),
        takeUntilDestroyed()
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (this.isShipmentsUrl(event.url)) {
            this.appShellState.hideAppChrome();
          } else {
            this.appShellState.showAppChrome();
          }
        }

        if (
          event === null ||
          event instanceof NavigationEnd
        ) {
          this.useElevatedContentSurface.set(
            this.resolveUseElevatedContentSurface()
          );

          if (
            event === null &&
            this.isShipmentsUrl(this.router.url)
          ) {
            this.appShellState.hideAppChrome();
          }
        }
      });
  }

  private isShipmentsUrl(url: string): boolean {
    const path = url.split(/[?#]/, 1)[0];

    return /^\/(?:shipments|expedition)(?:\/|$)/i.test(path);
  }

  private resolveUseElevatedContentSurface(): boolean {
    let route: ActivatedRoute | null =
      this.activatedRoute;

    while (route?.firstChild) {
      route = route.firstChild;
    }

    return (
      route?.snapshot?.data?.[
        'useElevatedContentSurface'
      ] !== false
    );
  }
}